<script setup lang="ts">
import './assets/style.scss'
import { useMeta } from '@/shared/lib'
import { useCabinetMain } from '@/entities/Cabinet'
import { computed, defineAsyncComponent, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import { ReportForm } from '@/features/Cabinet/Report'
import CabinetReportsMeterTabs from './CabinetReportsMeterTabs.vue'
import { useCabinetReports } from '@/pages/object/CabinetReports'
import CabinetReportsTypeTabs from './CabinetReportsTypeTabs.vue'
import CabinetReportContentTabs from './CabinetReportContentTabs.vue'
import {
  type ReportSubscriptionType,
  useSendUserSubscription,
  WReportSubscription,
} from '@/widgets'

useMeta().set({
  title: 'itf.reports',
})

const model = useCabinetMain()
const report = useCabinetReports()
const route = useRoute()
const { send } = useSendUserSubscription()

/** Обновляем данные при смене объекты */
watchEffect(() => {
  if (model.cabinet) {
    report.metersCount = model.cabinet?.meters.length || 1
    report.filter.meter = -1
  }
})

/** Вычисляем тип компонента в зависимости от вкладки */
const reportComponent = computed(() => {
  switch (route.params.report_type) {
    case 'consumption_days':
      return defineAsyncComponent(
        () => import('@/entities/Cabinet/ReportConsDays/ui/ReportConsDays.vue'),
      )
    case 'consumption_period':
      return defineAsyncComponent(
        () => import('@/entities/Cabinet/ReportConsPeriod/ui/ReportConsPeriod.vue'),
      )
    case 'current':
      return defineAsyncComponent(
        () => import('@/entities/Cabinet/ReportCurrent/ui/ReportCurrent.vue'),
      )
    case 'current_archive':
      return defineAsyncComponent(
        () => import('@/entities/Cabinet/ReportCurrentArchive/ui/ReportCurrentArchive.vue'),
      )
    case 'inventory':
      return defineAsyncComponent(
        () => import('@/entities/Cabinet/ReportInventory/ui/ReportInventory.vue'),
      )
    case 'time_slice':
      return defineAsyncComponent(
        () => import('@/entities/Cabinet/ReportTimeSlice/ui/ReportTimeSlice.vue'),
      )
    case 'consumption_compare':
      return defineAsyncComponent(
        () => import('@/entities/Cabinet/ReportConsCompare/ui/ReportConsCompare.vue'),
      )
    case 'green_glade':
      return defineAsyncComponent(
        () => import('@/entities/Cabinet/ReportGreenGlade/ui/ReportGreenGlade.vue'),
      )
    default:
      return defineAsyncComponent(
        () => import('@/entities/Cabinet/ReportReadings/ui/ReportReadings.vue'),
      )
  }
})

/** Функция обработчик оформления подписки */
const submitHandler = (data: ReportSubscriptionType) => {
  send({
    ...data,
    object_list_id: Number(route.params.object_id),
    report_type: route.params.report_type as string,
    filters: report.filter,
  })
}
</script>

<template>
  <!-- <CabinetReportsMeterTabs /> -->

  <CabinetReportsTypeTabs />

  <ReportForm />

  <CabinetReportContentTabs />

  <component :is="reportComponent" />

  <WReportSubscription :title="$t('itf.cabinet_report_subscription')" @submit="submitHandler" />
</template>
